"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});

var float16_1 = require("@petamoriken/float16");

var DataView64 = /*#__PURE__*/function () {
  function DataView64(arrayBuffer) {
    (0, _classCallCheck2.default)(this, DataView64);
    this._dataView = new DataView(arrayBuffer);
  }

  (0, _createClass2.default)(DataView64, [{
    key: "buffer",
    get: function get() {
      return this._dataView.buffer;
    }
  }, {
    key: "getUint64",
    value: function getUint64(offset, littleEndian) {
      var left = this.getUint32(offset, littleEndian);
      var right = this.getUint32(offset + 4, littleEndian);
      var combined;

      if (littleEndian) {
        combined = left + Math.pow(2, 32) * right;

        if (!Number.isSafeInteger(combined)) {
          throw new Error("".concat(combined, " exceeds MAX_SAFE_INTEGER. ") + 'Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues');
        }

        return combined;
      }

      combined = Math.pow(2, 32) * left + right;

      if (!Number.isSafeInteger(combined)) {
        throw new Error("".concat(combined, " exceeds MAX_SAFE_INTEGER. ") + 'Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues');
      }

      return combined;
    } // adapted from https://stackoverflow.com/a/55338384/8060591

  }, {
    key: "getInt64",
    value: function getInt64(offset, littleEndian) {
      var value = 0;
      var isNegative = (this._dataView.getUint8(offset + (littleEndian ? 7 : 0)) & 0x80) > 0;
      var carrying = true;

      for (var i = 0; i < 8; i++) {
        var byte = this._dataView.getUint8(offset + (littleEndian ? i : 7 - i));

        if (isNegative) {
          if (carrying) {
            if (byte !== 0x00) {
              byte = ~(byte - 1) & 0xff;
              carrying = false;
            }
          } else {
            byte = ~byte & 0xff;
          }
        }

        value += byte * Math.pow(256, i);
      }

      if (isNegative) {
        value = -value;
      }

      return value;
    }
  }, {
    key: "getUint8",
    value: function getUint8(offset, littleEndian) {
      return this._dataView.getUint8(offset, littleEndian);
    }
  }, {
    key: "getInt8",
    value: function getInt8(offset, littleEndian) {
      return this._dataView.getInt8(offset, littleEndian);
    }
  }, {
    key: "getUint16",
    value: function getUint16(offset, littleEndian) {
      return this._dataView.getUint16(offset, littleEndian);
    }
  }, {
    key: "getInt16",
    value: function getInt16(offset, littleEndian) {
      return this._dataView.getInt16(offset, littleEndian);
    }
  }, {
    key: "getUint32",
    value: function getUint32(offset, littleEndian) {
      return this._dataView.getUint32(offset, littleEndian);
    }
  }, {
    key: "getInt32",
    value: function getInt32(offset, littleEndian) {
      return this._dataView.getInt32(offset, littleEndian);
    }
  }, {
    key: "getFloat16",
    value: function getFloat16(offset, littleEndian) {
      return (0, float16_1.getFloat16)(this._dataView, offset, littleEndian);
    }
  }, {
    key: "getFloat32",
    value: function getFloat32(offset, littleEndian) {
      return this._dataView.getFloat32(offset, littleEndian);
    }
  }, {
    key: "getFloat64",
    value: function getFloat64(offset, littleEndian) {
      return this._dataView.getFloat64(offset, littleEndian);
    }
  }]);
  return DataView64;
}();

exports.default = DataView64;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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